var n="aptos:signTransaction";export{n as a};
//# sourceMappingURL=chunk-K5ZY2NHG.mjs.map